import { FC } from 'react';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { useLasdabPageModel } from '../../../../api/rs-hg/liquidity/hooks/queries';
import { LasdabCplRiskReport } from '../lasdab/lasdab.types';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import CounterpartyTableDisplay from './tableDisplay/tableDisplay.component';

const CounterpartyMarketLiquidityRisk: FC<FundInfoComponentProps> = (props) => {
  const query = useLasdabPageModel(props.fundId, props.positionDate);

  return (
    <QueryBoundary<LasdabCplRiskReport>
      isLoading={query.isLoading}
      isFetching={query.isFetching}
      isError={query.isError}
      error={query.error}
      data={query.data?.data}
      loadingMessages={['Loading counterparty liquidity data...']}
      noDataMessage="No counterparty liquidity data available."
    >
      {(data) => <CounterpartyTableDisplay data={data} />}
    </QueryBoundary>
  );
};

export default CounterpartyMarketLiquidityRisk;
